import list from './list'

const technicians =
{
    ...list,
    helmet :
    {
        title : 'Techniciens' ,
        metas : []
    },
    empty  : 'Aucun technicien trouvé',
    search : 'Rechercher un technicien ...' ,
    title  : 'Techniciens'
};

export default technicians ;
